const en_master_goodsPriceTier = {
    "": "Price Level",
    title: "Price Level [ {{ item }} ]",

    error: {
        edit: "Failed to update price level",
    },

    success: {
        edit: "Price level updated successfully",
    },
}

export default en_master_goodsPriceTier;